import React, { useState } from 'react';
import {
	Box,
	Checkbox,
	ListItemText,
	Menu,
	MenuItem,
	TableCell,
	TableHead,
	TableRow,
	TableSortLabel,
	Typography,
} from '@mui/material';
import _ from 'lodash';
import { columnType, tableState, Order, dataType } from '../types';
import { visuallyHidden } from '@mui/utils';
import { MenuFilter } from './MenuFilter';

interface IProps {
	onRequestSort: (tableState: tableState, setState: any, property: string) => void;
	order: Order;
	orderBy: string;
	headCells: columnType[];
	tableState: tableState;
	setState: any;
	noShrink?: boolean;
	data?: dataType[];
}
export type SelectedList = { name: string; value: string }[];

export const BasicTableHeader: React.FC<IProps> = ({
	order,
	orderBy,
	onRequestSort,
	setState,
	tableState,
	headCells,
	noShrink,
	data = [],
}) => {
	const createSortHandler = (event: any, property: columnType) => {
		if (property?.columnFilter) {
			setColumnsFilterState({ ...columnsFilterState, [property.name]: event.target });
			setOpenColumnsFilter(property.name);
		} else {
			onRequestSort(tableState, setState, property.name);
		}
	};

	const handleClose = (action?: string) => {
		const clone = { ...columnsFilterState };
		_.keys(clone).forEach((key) => {
			_.assign(clone, { [key]: null });
		});
		setColumnsFilterState(clone);
		setOpenColumnsFilter(undefined);
	};
	//in case there is filter columns declare menu state
	const columnsState = {};
	headCells.forEach((headCell) =>
		_.assign(columnsState, {
			[headCell.name]: null,
		})
	);

	const [columnsFilterState, setColumnsFilterState] = useState(columnsState);
	const [openColumnsFilter, setOpenColumnsFilter] = useState<string | undefined>();

	return (
		<TableHead className="BasicTable-TableHead">
			<TableRow className="BasicTable-TableHeadRow">
				{headCells.map((headCell, inx) => {
					const options: SelectedList = [];
					if (headCell?.columnFilter) {
						const uniques = _.keys(_.groupBy(data, headCell.name));
						uniques.forEach((val) => options.push({ name: val, value: val }));
					}
					return (
						<TableCell
							className="BasicTable-TableHeadCell"
							key={headCell.name + inx}
							sortDirection={orderBy === headCell.name ? order : false}
						>
							{headCell.sortable || headCell.columnFilter ? (
								<TableSortLabel
									active={orderBy === headCell.name}
									direction={orderBy === headCell.name ? order : 'asc'}
									className="BasicTable-tableHeadSortLabel"
									hideSortIcon={false}
								>
									<span className="BasicTable-tableText">{headCell.title}</span>
									<Box
										component={'a'}
										onClick={(event) => {
											createSortHandler(event, headCell);
										}}
										className="BasicTable-SortIcon"
									>
										&nbsp;
									</Box>
									{headCell.columnFilter && (
										<MenuFilter
											columnType={headCell.type}
											options={options}
											open={_.isEqual(openColumnsFilter, headCell.name)}
											anchorEl={_.get(columnsFilterState, headCell.name)}
											handleClose={handleClose}
											listHandleChange={(list) => {
												const filterData = { ...tableState.filters, [headCell.name]: list };
												if (list.length < 1 && _.has(filterData, headCell.name)) {
													delete filterData[headCell.name];
												}
												setState({ ...tableState, filters: filterData, page: 0 });
											}}
											termSearchHandleChange={(term) => {
												const filterData = {
													...tableState.filters,
													termSearch: { [headCell.name]: term },
												};
												setState({ ...tableState, filters: filterData, page: 0 });
											}}
											sorthHandleChange={(order) => {
												onRequestSort(
													{ ...tableState, orderBy: order },
													setState,
													headCell.name
												);
											}}
										/>
									)}
									{orderBy === headCell.name ? (
										<Box component="span" sx={visuallyHidden}>
											{order === 'desc' ? 'sorted descending' : 'sorted ascending'}
										</Box>
									) : null}
								</TableSortLabel>
							) : (
								<span className="BasicTable-tableText">{headCell.title}</span>
							)}
						</TableCell>
					);
				})}
				{!noShrink && <TableCell width="100%"></TableCell>}
			</TableRow>
		</TableHead>
	);
};

export default BasicTableHeader;
